export default {
  picks: {
    title: "Minhas escolhas",
    actions: {
      selectLocation: "Selecionar localização",
      importPhoto: "Importar foto",
      takePhoto: "Tirar foto",
      selectOperatorToContinue: "Selecione o operador para continuar",
      openOn: "Abrir na {{operator}}",
      visit: "Visitar {{operator}}",
    },
    locationGate: {
      title: "Permita que o Linemate acesse sua localização para usar Minhas escolhas",
      subtitle: "O Linemate usa sua localização para mostrar mercados e ofertas disponíveis na sua região.",
    },
    empty: {
      title: "Ainda não há escolhas",
      subtitle: "Toque em qualquer tendência para adicioná-la ou compartilhe uma foto e nós capturamos as escolhas para você.",
    },
    imageImport: {
      title: "Importar escolhas",
      scanningBetslip: "Escaneando seu betslip...",
      analyzingImage: "Analisando sua imagem...",
      detectingOdds: "Detectando odds",
      failed: "Falha ao importar escolhas",
      pleaseTryAgain: "Tente novamente",
      tryAgain: "Tentar novamente",
    },
    labels: {
      parlay: "Parlay",
      sgp: "SGP",
      straight: "Simples",
      legParlay: "Parlay de {{count}} legs",
      pricingUnavailable: "Preço indisponível",
      continueToOperator: "Continuar para seu operador",
    },
    sections: {
      availableOrAdjusted: "Todas as props disponíveis ou ajustadas",
      missingProps: "Props ausentes",
      unavailableInRegion: "Não disponível na sua região",
    },
    warnings: {
      legsNotFound_one: "{{count}} leg não pôde ser encontrada",
      legsNotFound_other: "{{count}} legs não puderam ser encontradas",
      adjusted_one: "{{count}} leg foi ajustada",
      adjusted_other: "{{count}} legs foram ajustadas",
      and: " e ",
      forOperator: " para {{operator}}.",
    },
  },
};